

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { featureHead, featureModuleHead } from "../../../../../config/constant";
import { NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import clsx from "clsx";

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, onEdit, onDelete, onView, loadMore, loadMoreContent, loadMoreTask, from, roleManagement } = props;
    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={from === 'Feature List' ? featureHead : featureModuleHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={from === 'Module List' ? 4 : 3}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                                <TableCell style={{ width: getColumnWidth(from === 'Feature List' ? featureHead : featureModuleHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission(from, 'view', 'Younote Admin') ?
                                                            <NavLink style={{ width: getColumnWidth(from === 'Feature List' ? featureHead : featureModuleHead, 0) }} to={"#"} className={clsx(classes.color, classes.bold)} onClick={() => onView(data)}>{data.featureName}</NavLink> : data.featureName
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(from === 'Feature List' ? featureHead : featureModuleHead, 0) }}><span style={{ width: getColumnWidth(from === 'Feature List' ? featureHead : featureModuleHead, 0) }}>{data.description}</span></TableCell>
                                                {
                                                    from === 'Feature List' && <TableCell >{data?.module?.module}</TableCell>
                                                }
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission(from, 'view', 'Younote Admin') &&
                                                            <>
                                                                {
                                                                    <NavLink to={"#"} onClick={() => onView(data)}>
                                                                        <Image
                                                                            src={ViewIcon}
                                                                            preview={false}
                                                                        />
                                                                    </NavLink>
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission(from, 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission(from, 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={from === 'module' ? 4 : 3}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment >
                            )
                        }
                    </>
                }
            />
        </>
    )
}